import React from "react";
import { Link } from "react-router-dom";
import "./LegalPage.css";

function LunicaAITerms() {
  return (
    <div className="legal-page">
      <div className="legal-header">
        <div className="legal-header-content">
          <img src="/images/lunicaai_logo.png" alt="Lunica AI Logo" />
          <div>
            <h1>Lunica AI Terms of Use</h1>
            <p>Intelligent Creative Companion</p>
          </div>
        </div>
        <Link to="/" className="legal-back-link">← Back to OnyxUp</Link>
      </div>

      <div className="legal-content">
          <h2>End User License Agreement (EULA)</h2>
          <p><strong>Last Updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          
          <h3>1. License Grant</h3>
          <p>OnyxUp grants you a limited, non-exclusive, non-transferable license to use the Lunica AI mobile application ("App") on your personal device, subject to the terms of this agreement.</p>
          
          <h3>2. License Restrictions</h3>
          <p>You may not:</p>
          <ul>
            <li>Reverse engineer, decompile, or disassemble the App</li>
            <li>Modify, adapt, or create derivative works</li>
            <li>Distribute, sublicense, or transfer the App</li>
            <li>Use the App for commercial purposes without permission</li>
          </ul>
          
          <h3>3. User Content and Responsibilities</h3>
          <p>You are solely responsible for:</p>
          <ul>
            <li>Content you upload or create using the App</li>
            <li>Ensuring you have rights to any content you process</li>
            <li>Compliance with applicable laws and regulations</li>
            <li>Not uploading inappropriate, illegal, or harmful content</li>
          </ul>
          
          <h3>4. Intellectual Property</h3>
          <p>The App and all its content, features, and functionality are owned by OnyxUp and protected by copyright, trademark, and other intellectual property laws.</p>
          
          <h3>5. Privacy and Data</h3>
          <p>Your use of the App is also governed by our Privacy Policy. By using the App, you consent to the collection and use of information as described in our Privacy Policy.</p>
          
          <h3>6. Disclaimers and Limitations</h3>
          <p>THE APP IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND. ONYXUP DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.</p>
          
          <h3>7. Limitation of Liability</h3>
          <p>IN NO EVENT SHALL ONYXUP BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR USE OF THE APP.</p>
          
          <h3>8. Termination</h3>
          <p>This license is effective until terminated. OnyxUp may terminate this license immediately if you breach any terms. Upon termination, you must cease all use of the App.</p>
          
          <h3>9. Updates and Modifications</h3>
          <p>OnyxUp may provide updates to the App. Continued use after updates constitutes acceptance of any modified terms.</p>
          
          <h3>10. Governing Law</h3>
          <p>This agreement is governed by the laws of Turkey. Any disputes shall be resolved in Turkish courts.</p>
          
          <h3>11. Contact Information</h3>
          <p>For questions about this EULA, contact us at:</p>
          <p>📧 <a href="mailto:info@onyxup.net">info@onyxup.net</a></p>
      </div>
    </div>
  );
}

export default LunicaAITerms;



